import React from 'react'
import { Moon, Sun } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useUIStore } from '@/store/ui.store'
import { useTranslation } from 'react-i18next'

/**
 * Theme toggle component with light, dark, and system options
 * Uses shadcn/ui theme system and integrates with UI store
 */
export const ThemeToggle: React.FC = () => {
  const { t } = useTranslation('common')
  const { theme, setTheme } = useUIStore()

  const themeIcon = {
    light: Sun,
    dark: Moon,
  }

  const CurrentIcon = themeIcon[theme as 'light' | 'dark'] || Sun

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8 p-0">
          <div className="w-8 h-8 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
            <CurrentIcon className="h-3 w-3 text-white" />
          </div>
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setTheme('light')}>
          <Sun className="mr-2 h-4 w-4" />
          <span>{t('theme.light')}</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('dark')}>
          <Moon className="mr-2 h-4 w-4" />
          <span>{t('theme.dark')}</span>
        </DropdownMenuItem>
        {/* System option removed per requirement: only Light and Dark */}
      </DropdownMenuContent>
    </DropdownMenu>
  )
} 